import React, {useRef, useState} from 'react'
import ModuleNavbar from 'components/Navbars/ModuleNavbar'
import Material from './Material';
import Personal from './Personal';
import { connect } from 'react-redux'
import { getMaterials, getPersonel, getProcedOPK , getPersonelCategory, getProcedures, getICD9, getOPK507} from 'actions/procedureDefActions';
import Procedure from './Procedure';


// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Row,
    Col,
    Button, 
    Nav, NavItem, NavLink
} from "reactstrap";
import {
    getMaterialTypes,
    getUnitTypes,
    postAvailablePersonel,
    postMaterialType,
    postUnitType
} from "../../../actions/procedureDefActions";


const Definition = (props) => {
    const {getMaterials, materials, getPersonel, personel, getProcedOPK, opk, getPersonelCategory, categories,
    getProcedures, procedures, getICD9, icd9,
    getOPK507, opk507,unitTypes,materialTypes,getMaterialTypes,postUnitType,getUnitTypes,postMaterialType,typeLoading,postAvailablePersonel, newMaterial, newUnit, newPersonelCat} = props
    React.useEffect(()=>{
        let params= {ordering:'-id'}
        getMaterials(params)
        getPersonel(params)
        getProcedOPK()
        getPersonelCategory()
        getProcedures({ordering:'-id', active:"true"})//, calculated:"true"
        getOPK507()
        getMaterialTypes()
        getUnitTypes()
    // eslint-disable-next-line
    },[])
    const [func, setFunc] = useState(false);
    const buttonSize = useRef(null)

    const displayFunction = (e) => {
        setFunc(!func);
    }
    const [active, setActive] = React.useState(1)

    const searchICD = (value, type)=>{
        if(type==='number' && value.length>0){
            let params = {code_search:value}
            getICD9(params)}
        if( type==='name' && value.length>2){
            getICD9({name_search:value})
        }
    }
    const proceduresFilter = (opk,search) =>{
        getProcedures({ordering:'-id', active:"true",opk_procedural:opk, search:search})
    }
    return (
    <div className="content">
        <ModuleNavbar title='Wycena Procedur Medycznych/Usług' color='#006ba7' icon='nc-icon nc-money-coins' func={displayFunction} page={18}/>
        {!func ?<Row>
            <Col md="12">
            <Card>
                <CardBody>
                <Row className='text-center'> 
                    <Col md="12" sm="12" className='inline ml-auto mr-auto'>
                    <div className="nav-tabs-navigation"> <div className="nav-tabs-wrapper">
                        <Nav id="tabs" role="tablist" tabs>
                            <NavItem>
                                <NavLink aria-expanded={active === 1} data-toggle="tab" role="tab" tabIndex={'0'} style={{cursor: 'pointer'}}
                                className={active === 1 ? "active wycenaPanel" : ""} onClick={()=>{setActive(1)}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setActive(1)
                                    }
                                }} >
                                    Zasoby Materiałowe
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink aria-expanded={active === 2} data-toggle="tab" tabIndex={'0'} role="tab" style={{cursor: 'pointer'}}
                                className={active === 2 ? "active wycenaPanel" : ""} onClick={()=>{setActive(2)}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setActive(2)
                                    }
                                }}>
                                    Zasoby Osobowe
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink aria-expanded={active === 3} data-toggle="tab" tabIndex={'0'} role="tab" style={{cursor: 'pointer'}}
                                className={active === 3 ? "active wycenaPanel" : ""} onClick={()=>{setActive(3)}}
                                 onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setActive(3)
                                    }
                                }}>
                                    Realizowane procedury
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div> </div>

                        {/* <Button size="lg" className="btn-round mr-5 spac"  style={active===1? {...containerDivStyle( {dark:'#006ba7',light: '#006ba7'},), ...{textDecoration: 'underline', textShadow: '#9c9c9c 2px 2px 2px'}}: {...containerDivStyle( {dark:'#006ba7',light: '#006ba7'},)}} className="mx-4" onClick={()=>{setActive(1)}}>Zasoby materiałowe</Button>
                        <Button size="lg" className="btn-round ml-5 mr-5"  style={active===2? {...containerDivStyle( {dark:'#006ba7',light: '#006ba7'},), ...{textDecoration: 'underline', textShadow: '#9c9c9c 2px 2px 2px'}}: {...containerDivStyle( {dark:'#006ba7',light: '#006ba7'},)}} className="mx-4" onClick={()=>{setActive(2)}}>Zasoby osobowe</Button>
                        <Button size="lg" className="btn-round mr-5"  style={active===3? {...containerDivStyle( {dark:'#006ba7',light: '#006ba7'},), ...{textDecoration: 'underline', textShadow: '#9c9c9c 2px 2px 2px'}}: {...containerDivStyle( {dark:'#006ba7',light: '#006ba7'},)}} className="mx-4" onClick={()=>{setActive(3)}}>Dostępne procedury</Button>
                        {/* <div style={{...containerDivStyle( {dark:'#207893',light: '#66cef1'},), width:'40px',height:'40px'}}></div> */}
                        {/* <Button size="lg" className="btn-round mr-5 spac"  style={active===1? {...containerDivStyle( {dark:'#257992',light: '#badde1'},)}: {...containerDivStyle( {dark:'#0093cf',light: 'white'},)}} className="mx-4" onClick={()=>{setActive(1)}}>Zasoby materiałowe</Button>
                        <Button size="lg" className="btn-round ml-5 mr-5"  style={active===2? {...containerDivStyle( {dark:'#257992',light: '#badde1'},)}: {...containerDivStyle( {dark:'#0093CF',light: 'white'},)}} className="mx-4" onClick={()=>{setActive(2)}}>Zasoby osobowe</Button>
                        <Button size="lg" className="btn-round mr-5"  style={active===3? {...containerDivStyle( {dark:'#257992',light: '#badde1'},)}: {...containerDivStyle( {dark:'#0093CF',light: 'white'},)}} className="mx-4" onClick={()=>{setActive(3)}}>Dostępne procedury</Button> */} 
                    </Col>
                </Row>
                <Row>
                    <Col  md="12" sm="12" className='ml-auto mr-auto'>

                    {active === 1 &&  <Material newMaterial={newMaterial} newUnit={newUnit}  materials={materials} typeLoading={typeLoading} unitTypes={unitTypes} postUnitType={postUnitType} materialTypes={materialTypes} postMaterialType={postMaterialType}></Material>}
                    {active === 2 &&  <Personal newPersonelCat={newPersonelCat} typeLoading={typeLoading} personel={personel} categories={categories} opk={opk507} postAvailablePersonel={postAvailablePersonel} ></Personal>}
                    {active === 3 &&  <Procedure procedures={procedures} proceduresFilter={proceduresFilter} searchICD={searchICD} icd9={icd9} opk507={opk507}></Procedure>}

                    </Col>
                </Row>
                </CardBody>
                </Card>
            </Col>
        </Row>: <>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h5">
                            Drogi Użytkowniku,
                        </CardTitle>
                    </CardHeader>


                    <CardBody style={{textAlign: 'justify', lineHeight: '2', fontSize: '14px'}}>
                    w&nbsp;panelu <span className='text-wycena'>„Definicje”</span> masz możliwość zdefiniowania zasobów materiałowych, osobowych i&nbsp;realizowanych 
                    procedur lub zaimplementowania ich w&nbsp;formie plików MS&nbsp;Excel.
                    <br/><br />
                    Aby zdefiniować zasoby materiałowe:
                    <ul>
                        <li>wybierz zakładkę „Zasoby materiałowe”,</li>
                        <li>
                            <u>poprzez import</u>, należy w&nbsp;pierwszej kolejności za&nbsp;pomocą przycisku 
                            <Button size='sm' className="btn-round my-0 mx-2" color="wycena" outline type="button">
                                <i className="fas fa-download mr-2"/> Pobierz szablon pliku
                            </Button>
                            pobrać wzorcowy arkusz MS&nbsp;Excel, w&nbsp;którym musisz uzupełnić pola:<br/>
                            - indeks materiału/wyrobu,<br/>
                            - nazwa materiału/wyrobu,<br/>
                            - typ,<br/>
                            - jednostka miary<br/>
                            - cena jednostki miary w&nbsp;zł,<br/>
                            - ilość w&nbsp;opakowaniu.<br/>
                            Aby przesłać plik z&nbsp;zasobami, za&nbsp;pomocą przycisku 
                            <Button size='sm' className="btn-round my-0 mx-2" color="wycena" type="button"> Wybierz </Button>, 
                            odszukaj uzupełniony szablon pliku i&nbsp;kliknij w przycisk
                            <Button size='sm' className="btn-round m-0 mx-2" color="wycena" outline type="button">
                                <i className="fas fa-upload mr-2"/> Prześlij plik
                            </Button>, 
                            w&nbsp;celu wgrania go&nbsp;do&nbsp;aplikacji.
                        </li>
                        <li>
                            <u>bezpośrednio w&nbsp;aplikacji</u>, należy uzupełnić kolejno pola:<br/>
                            - indeks materiału,<br/>
                            - materiał/lek/środek spożywczy…,<br/>
                            - typ,<br/>
                            - jednostka miary<br/>
                            - cena w&nbsp;zł.<br/>
                            - i&nbsp;kliknij w przycisk <Button className="btn btn-round my-0 mx-2" outline size='sm' color="wycena" type="button" >
                                    <i className='nc-icon nc-simple-add'></i>
                                </Button> dodaj.
                        </li>
                    </ul>
                    Pole „typ” i&nbsp;„jednostka miary” możesz wybrać ze&nbsp;zdefiniowanej listy lub dodać własne kryterium, wpisując je i&nbsp;klikając „Enter”.
                    <br/>
                    Dodany zasób pojawi się na&nbsp;liście zasobów.
                    <br/>
                    Poprzez opcje masz możliwość usunięcia go&nbsp;z&nbsp;listy lub edytowania jego poszczególnych składowych.
                    <br/><br />
                    Aby zdefiniować zasoby osobowe:
                    <ul>
                        <li>wybierz zakładkę „Zasoby osobowe”,</li>
                        <li>
                            <u>poprzez import</u>, należy w&nbsp;pierwszej kolejności za&nbsp;pomocą przycisku
                            <Button size='sm' className="btn-round my-0 mx-2" color="wycena" outline type="button">
                                <i className="fas fa-download mr-2"/> Pobierz szablon pliku
                            </Button> 
                            pobrać wzorcowy arkusz MS&nbsp;Excel, w&nbsp;którym należy uzupełnić pola:<br/>
                            - numer OPK,<br/>
                            - nazwa OPK,<br/>
                            - kategoria personelu,<br/>
                            - stawka w&nbsp;zł/h<br/>
                            - stawka w&nbsp;zł/procedurę.<br/>
                            Aby przesłać plik z&nbsp;zasobami, za&nbsp;pomocą przycisku 
                            <Button size='sm' className="btn-round my-0 mx-2" color="wycena" type="button"> Wybierz </Button>,
                            odszukaj uzupełniony szablon pliku i kliknij w przycisk 
                            <Button size='sm' className="btn-round m-0 mx-2" color="wycena" outline type="button">
                                <i className="fas fa-upload mr-2"/> Prześlij plik
                            </Button>,
                            w&nbsp;celu wgrania go&nbsp;do&nbsp;aplikacji.
                        </li>
                        <li>
                            <u>bezpośrednio w&nbsp;aplikacji</u>, należy uzupełnić kolejno pola:
                            - numer OPK,
                            - kategoria personelu,
                            - stawka w&nbsp;zł/h
                            - stawka w&nbsp;zł/procedurę,
                            - i&nbsp;kliknij w&nbsp;przycisk <Button className="btn btn-round my-0 mx-2" outline size='sm' color="wycena" type="button" >
                                    <i className='nc-icon nc-simple-add'></i>
                                </Button> dodaj.
                        </li>
                    </ul>
                    Pole „kategoria personelu” możesz wybrać ze&nbsp;zdefiniowanej listy lub dodać własne kryterium, wpisując je&nbsp;i&nbsp;klikając „Enter”.
                    <br />
                    Dodany zasób pojawi się na&nbsp;liście zasobów.
                    <br />
                    Poprzez opcje masz możliwość usunięcia go&nbsp;z&nbsp;listy lub edytowania jego poszczególnych składowych.
                    <br /><br />
                    Aby zdefiniować realizowane procedury/usługi:
                    <ul>
                        <li>wybierz zakładkę „Realizowane procedury/usługi”,</li>
                        <li>
                            <u>poprzez import</u>, należy w&nbsp;pierwszej kolejności za&nbsp;pomocą przycisku 
                            <Button size='sm' className="btn-round my-0 mx-2" color="wycena" outline type="button">
                                <i className="fas fa-download mr-2"/> Pobierz szablon pliku
                            </Button>, pobrać wzorcowy arkusz MS&nbsp;Excel, w&nbsp;którym musisz uzupełnić pola:<br/>
                            - kod procedury/usługi wg&nbsp;ICD-9,<br/>
                            - nazwa procedury/usługi wg&nbsp;ICD-9,<br/>
                            - kod procedury/usługi wg&nbsp;świadczeniodawcy,<br/>
                            - nazwa procedury/usługi wg&nbsp;świadczeniodawcy,<br/>
                            - numer OPK, w&nbsp;którym dana procedura/usługa jest wykonywana,<br/>
                            - data początkowa obowiązywania.<br/>
                            Aby przesłać plik z&nbsp;zasobami, za&nbsp;pomocą przycisku 
                            <Button size='sm' className="btn-round my-0 mx-2" color="wycena" type="button"> Wybierz </Button>,
                            odszukaj uzupełniony szablon pliku i&nbsp;kliknij w przycisk 
                            <Button size='sm' className="btn-round m-0 mx-2" color="wycena" outline type="button">
                                <i className="fas fa-upload mr-2"/> Prześlij plik
                            </Button>, 
                            w&nbsp;celu wgrania go&nbsp;do&nbsp;aplikacji.
                        </li>
                        <li>
                            <u>bezpośrednio w&nbsp;aplikacji</u>, należy uzupełnić kolejno pola:<br/>
                            - kod procedury/usługi wg&nbsp;ICD-9,<br/>
                            - nazwa procedury wg&nbsp;ICD-9,<br/>
                            - kod procedury/usługi wg&nbsp;świadczeniodawcy,<br/>
                            - nazwa procedury/usługi wg&nbsp;świadczeniodawcy,<br/>
                            - numer OPK, w&nbsp;którym dana procedura/usługa jest wykonywana,<br/>
                            - data początkowa i&nbsp;końcowa obowiązywania,<br/>
                            - i&nbsp;kliknij w&nbsp;przycisk <Button className="btn btn-round my-0 mx-2" outline size='sm' color="wycena" type="button" >
                                    <i className='nc-icon nc-simple-add'></i>
                                </Button> dodaj.
                        </li>
                    </ul>
                    Dodana procedura/usługa pojawi się na&nbsp;liście realizowanych procedur/usług w&nbsp;Twoim podmiocie.
                    <br/>
                    Poprzez opcje masz możliwość wprowadzenia daty końcowej w&nbsp;przypadku rezygnacji z&nbsp;wykonywania danej procedury/usługi.
                    <br/>
                         <Button className="btn-round" outline color="wycena" onClick={()=>{
                            window.focus();
                            window.scrollTo(0, 0);
                            displayFunction('main');
                            }} style={btnNewStyle}> Powrót </Button>
                    </CardBody>
                </Card>
            </>}
    </div>
    )
}
 
const mapStateToProps = state => ({
    materials:state.procedureDefReducer.materials,
    personel: state.procedureDefReducer.personel,
    opk:state.procedureDefReducer.opk,
    categories: state.procedureDefReducer.categories,
    procedures: state.procedureDefReducer.procedures,
    icd9: state.procedureDefReducer.icd9,
    opk507: state.procedureDefReducer.opk507,
    unitTypes:  state.procedureDefReducer.unitTypes,
    materialTypes:  state.procedureDefReducer.materialTypes,
    typeLoading:  state.procedureDefReducer.typeLoading,
    newMaterial: state.procedureDefReducer.newMaterial,
    newUnit: state.procedureDefReducer.newUnit,
    newPersonelCat: state.procedureDefReducer.newPersonelCat

})
const btnNewStyle = {
  float: 'right',
  margin: '0px !important'
}
const containerDivStyle = (colors) =>{
    return {
      boxShadow:'inset 0px 0px 13px 10px '+colors.dark,
      background:'linear-gradient(to bottom, '+colors.light+' 0%, '+colors.dark+' 70%)',
      backgroundColor: colors.light,
      border:'1px solid '+colors.dark,
      textShadow:'2px 2px 22px '+colors.light,
    }
  }

export default connect(mapStateToProps,{postAvailablePersonel,postUnitType,getUnitTypes,postMaterialType,getMaterialTypes,getMaterials, getPersonel, getProcedOPK,getPersonelCategory, getProcedures, getICD9, getOPK507})(Definition)
